var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "returnable-items-view" },
    [
      _c(
        "el-card",
        {
          staticClass: "item-card",
          class: { "highlighted-item-card": _vm.isSelected },
        },
        [
          _vm.images && _vm.images.length && _vm.images[0].src
            ? _c("img", {
                staticClass: "item-image",
                attrs: { alt: _vm.images[0].alt, src: _vm.images[0].src },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-auto", staticStyle: { "margin-left": "8px" } },
            [
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "item-name flex-1" }, [
                  _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-sku" }, [
                _vm._v("\n        ASIN:  " + _vm._s(_vm.sku) + "\n      "),
              ]),
            ]
          ),
          _vm._v(" "),
          (_vm.isSelected && !_vm.allSelected) ||
          (_vm.allSelected && _vm.selectedReason)
            ? _c("ItemReturnReasons", {
                attrs: {
                  "return-reasons": _vm.returnReasons,
                  "selected-reason": _vm.selectedReason,
                  "all-checked": _vm.allSelected,
                },
                on: { "selected-reason": _vm.setSelectedReason },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-checkbox", {
            staticStyle: { "margin-right": "16px" },
            attrs: { value: _vm.isSelected },
            on: { change: _vm.toggleSelection },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }